"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateLayout = void 0;
const get_random_item_util_1 = require("../helper/get-random-item.util");
const rotate_layout_0_util_1 = require("./rotate-layout-0.util");
const rotate_layout_180_util_1 = require("./rotate-layout-180.util");
const rotate_layout_270_util_1 = require("./rotate-layout-270.util");
const rotate_layout_90_util_1 = require("./rotate-layout-90.util");
const rotateLayout = (layout) => (0, get_random_item_util_1.getRandomItem)([rotate_layout_0_util_1.rotateLayout0, rotate_layout_90_util_1.rotateLayout90, rotate_layout_180_util_1.rotateLayout180, rotate_layout_270_util_1.rotateLayout270])(layout);
exports.rotateLayout = rotateLayout;
